import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { HeroSection } from "../../components/HeroSection";
import { StatsSection } from "../../components/StatsSection";
import { HowItWorksSection } from "../../components/HowItWorksSection";
import { FeaturesSection } from "../../components/FeaturesSection";
import { IntegrationsSection } from "../../components/IntegrationsSection";
import { TrustSection } from "../../components/TrustSection";
import { PricingSection } from "../../components/PricingSection";
import { JournalSection } from "../../components/JournalSection";
import { FAQSection } from "../../components/FAQSection";
import { FinalCtaSection } from "../../components/FinalCtaSection";
import { SignalLine } from "../../components/SignalLine";
import { FadedLine } from "../../components/FadedLine";

export default function Home() {
  return (
    <div className="min-h-screen bg-paper-white font-sans text-char">
      <Navbar />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <SignalLine />
        <FeaturesSection />
        <StatsSection />
        <FadedLine />
        <IntegrationsSection />
        <TrustSection />
        <PricingSection />
        <FadedLine />
        <JournalSection />
        <FadedLine />
        <FAQSection />
        <FinalCtaSection />
      </main>
      <Footer />
    </div>
  );
}
